import React from 'react';
import { useTranslation } from 'react-i18next';
import { AttachmentProps } from './Attachment.types';
import styles from './attachment.module.css';

const Attachment: React.FC<AttachmentProps> = ({ attachments = [] }) => {
  const { t } = useTranslation();

  const showAttachments = attachments.length > 0;

  if (!showAttachments) {
    return null;
  }

  return (
    <div className={styles.attachment}>
      {attachments.map((attachment, index) => (
        <a
          key={`${index}-${attachment.url ?? ''}`}
          href={attachment.url}
          className={styles.link}
          target="_blank"
          rel="noopener noreferrer"
        >
          <span>
            {attachment.caption ||
              t(
                `views.bookingDetail.attachmentType.${attachment.attachmentType}`
              )}
          </span>
        </a>
      ))}
    </div>
  );
};

export default Attachment;
